import { render, staticRenderFns } from "./dspHeader.vue?vue&type=template&id=afaa1d26&"
import script from "./dspHeader.vue?vue&type=script&lang=js&"
export * from "./dspHeader.vue?vue&type=script&lang=js&"
import style0 from "./dspHeader.vue?vue&type=style&index=0&id=afaa1d26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports